import { render, staticRenderFns } from "./modal-news.vue?vue&type=template&id=e7a324a0&"
import script from "./modal-news.vue?vue&type=script&lang=js&"
export * from "./modal-news.vue?vue&type=script&lang=js&"
import style0 from "./modal-news.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports